<template>
    <card v-if="showSignatureCard">
        <call-for-action
            :vertical="!compact"
            :reduce-text="false"
            :reduce-button="false"
            :action="$t('dashboard.mark-as-read')"
            :loading="signing"
            :handler="sign"
        >
            {{ $t('dashboard.mark-as-read-notice') }}
        </call-for-action>
    </card>
</template>

<script>
    import CallForAction from '../common/CallForAction'

    export default {

        components: {
            CallForAction
        },

        props: {

            simulation: {
                type: Object,
            },

            compact: {
                type: Boolean,
                default: false
            },
        },

        data() {
            return {
                justSigned: false,
                signing: false,
            }
        },

        computed: {

            showSignatureCard() {
                
                // Need to be published.
                if (!this.simulation.state.published) {
                    return false
                }
                
                // Need to be after learner date for assessments.
                if (this.simulation.assessment && !this.simulationAfterDate) {
                    return false
                }

                // Already signed.
                if (this.signed) {
                    return false
                }

                return true
            },

            simulationAfterDate() {
                return this.simulation.state.meta
                    && this.simulation.state.meta.learner_access_date
                    && new Date(this.simulation.state.meta.learner_access_date) <= new Date()
            },

            signed() {
                return this.justSigned || this.simulation.state.acknowledged
            }
        },

        methods: {

            sign() {
                this.signing = true
                axios.post('/astral/api/front/dashboard/registrations/'+this.$route.params.registrationId+'/simulations/'+this.$route.params.simulationId+'/sign')
                .then(resp => {
                    this.signing = false
                    this.justSigned = true
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>
